import useSWR from 'swr';
import { ConsentResponse } from '../../../types/ArtStyles';
import agreementImage from '../../../assets/agreement-image.png';
import api from '../../../utils/api';
import { Box } from '@mui/system';
import { ArtistStep, CreatorStep, getStepUrls, InfluencerStep } from '../common/signupSteps';
import { useSignup } from '../../context/SignupContext';
import { useEffect, useState, useRef } from 'react';
import { UserType } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '../common/Breadcrumbs';
import NextButton from '../common/NextButton';
import userClient from '../../../utils/apiClients/userClient';

const currentStepIndexMap: Partial<Record<UserType, CreatorStep | InfluencerStep | ArtistStep>> = {
  artist: 1
};

const ArtStyleAgreement = () => {
  const { account } = useSignup();
  const [currentStep, setCurrentStep] = useState<CreatorStep | InfluencerStep | ArtistStep>(0);
  const { previousUrl , nextUrl} = getStepUrls(account.userType, currentStep);
  const navigate = useNavigate();
  const hasCalledOnboarding = useRef(false);
  
  // Call onboarding API when artist enters this step (first step after profile selection)
  useEffect(() => {
    const callArtistOnboarding = async () => {
      if (account.userType === 'artist' && account.accountType && !hasCalledOnboarding.current) {
        hasCalledOnboarding.current = true;
        try {
          await userClient.put('/users/me/artist-profile', {
            accountType: account.accountType || 'personal'
          });
        } catch (error) {
          console.error('Error during artist onboarding:', error);
        }
      }
    };
    callArtistOnboarding();
  }, [account.userType, account.accountType]); // Include dependencies but use ref to ensure it only runs once

  const handleNext = async () => {
    navigate(nextUrl as string);
  };

  const handleSkip = () => {
    if (account.userType === 'artist') {
      return window.location.href = '/artist/dashboard';
    }
  };

  const handleClickBack = () => {
    navigate(previousUrl as string);
  };

  useEffect(() => {
    const tempStep = currentStepIndexMap[account.userType as UserType];
    if (tempStep !== undefined) {
      setCurrentStep(tempStep);
    }
  }, [account.userType]);

  const { data } = useSWR<{ data: ConsentResponse }>('/consent/v1/agreement/art-style', api);
  return (
    <Box>
      <Breadcrumbs handleSkip={handleSkip} isSkip={true} currentStep={currentStep} onClickBack={handleClickBack} />

      <div className="rounded-[10px] flex flex-col item-center w-full my-auto px-4 pt-6 pb-8  w-full data-[state=open]:animate-dialog-content-show data-[state=closed]:animate-dialog-content-hide mx-4 md:mx-0 md:pt-10 md:px-6">
        <img
          src={agreementImage}
          className="rounded-[5px] w-full object-contain mt-4 h-[8.875rem] md:h-[19.625rem]"
          alt=""
        />
        <h3 className="text-xl text-white font-inter font-medium mt-4">
          {data?.data.title}
        </h3>
        <p className="mt-4 text-[#F7F7F7] font-inter font-light text-sm">
                    By using this art style creation experience, you agree to the terms and conditions outlined in our License Agreement.
                    For detailed terms, please review the complete agreement at  <a target='_blank' className='underline' href="https://saagas.ai/copyright-license-agreement-artist" rel="noreferrer">
                        https://saagas.ai/copyright-license-agreement-artist
          </a>
        </p>
        
      </div>
      <NextButton buttonName='I agree, continue' isLoading={false} disabled={false} onClick={handleNext} />
    </Box>
  );
};

export default ArtStyleAgreement;
